import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.dark.css';
import Vue from 'vue'
import * as firebase from 'firebase'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import { store } from './store'
import gsap from "gsap";
import AudioVisual from 'vue-audio-visual'
import { LMap, LTileLayer, LMarker,LPopup, LPolyline, LCircle, LImageOverlay } from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';
import { CRS } from "leaflet";
import PrettyCheckbox from 'pretty-checkbox-vue';
import 'pretty-checkbox/src/pretty-checkbox.scss';



Vue.component('l-map', LMap);
Vue.component('l-tile-layer', LTileLayer);
Vue.component('l-marker', LMarker);
Vue.component('l-image-overlay', LImageOverlay);
Vue.component('l-popup',LPopup);
Vue.component('l-polyline', LPolyline );
Vue.component('l-circle', LCircle );
Vue.component('crs', CRS);
Vue.config.productionTip = false
Vue.use(AudioVisual)
Vue.use(PrettyCheckbox);
new Vue({
  router,
  store,
  render: h => h(App),
  created(){
    //var projectId="wreckseeker-f7"
    var projectId="wreckseeker-anmm"
  
    var firebaseConfig = {
      apiKey: "AIzaSyDY9tFRnR9lzcuhKkpDChEJ1DbV-f_mpGs",
      //apiKey: "AIzaSyAp_ZhASKbIfp3oF3g0lsI5uVjM2yZ22L4",
      authDomain: projectId+".firebaseapp.com",
      databaseURL: "https://"+projectId+".firebaseio.com",
      projectId: projectId,
      storageBucket: projectId+".appspot.com",
      //messagingSenderId: "277712220508",
     // appId: "1:277712220508:web:738c8de208a92795bb9199",
      //measurementId: "G-3CWES33HRG"
    };
    firebase.initializeApp(firebaseConfig );
    projectId="wreckseeker-anmm"
    var otherApp = firebase.initializeApp({
      apiKey: "AIzaSyAp_ZhASKbIfp3oF3g0lsI5uVjM2yZ22L4",
      appId: "1:908990215040:web:860116c71307d7e4888765",
      authDomain: projectId+".firebaseapp.com",
      databaseURL: "https://"+projectId+".firebaseio.com",
      projectId: projectId,
      storageBucket: projectId+".appspot.com",
    }, "wreckseeker-anmm");
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        this.$store.dispatch('autoSignIn', user)
        if (user.emailVerified) {
          //console.log('Email is verified');
        }
        else {
          //console.log('Email is not verified');
          /*
          user.sendEmailVerification().then(function() {
            console.log("EMAIL SENT",user)
          }).catch(function(error) {
            console.log("EMAIL An error happened.",error)
            // An error happened.
          });
          */
          
        }

      }else{
        //alert("No user")
      }
    })
  },
}).$mount('#app')
